import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.create";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.reflect.construct";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

This software is the confidential and proprietary information of Wells Fargo
bank. ('Confidential Information'). You shall not disclose such Confidential
Information and shall use it only in accordance with the terms of the license
agreement you entered into with WellsFargo.

Author: Thomas Barry

Description:

This is a special-purpose component used by the desktop global navigation menu. It
uses the render-prop pattern, and passes a 'isHoveringOver' parameter to the rendering
function provided in props.render. The value of 'isHoveringOver' if the current mouse
position is over the element using this component (<NavigationBarItem>), or if the
current mouse position is over the child-window opened by this component.

<NavigationBarItem> passes two properties to this component. The "render" props is a
function that renders the contents of the <NavigationBarItem> element. The "modalRef" prop
is a reference to the modal opened by the <NavigationBarItem> element.
*/
import React from 'react';
import PropTypes from 'prop-types';
import _debounce from 'lodash/debounce';
import Block from 'wfui-digital-core/es/Block';
import isMouseOverElement from '../../../../../lib/mouse-utils/mouse-utils';

var ReportMouseHover = /*#__PURE__*/function (_React$Component) {
  _inherits(ReportMouseHover, _React$Component);

  var _super = _createSuper(ReportMouseHover);

  function ReportMouseHover() {
    var _this;

    _classCallCheck(this, ReportMouseHover);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "setElementRef", function (element) {
      _this.elementRef = element;
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (event) {
      var menuRef = _this.props.menuRef;
      var overNavbar = isMouseOverElement({
        element: _this.elementRef,
        event: event
      });
      var overMenu = isMouseOverElement({
        element: menuRef,
        event: event
      });

      if (overMenu !== _this.state.overMenu || overNavbar !== _this.state.overNavbar) {
        _this.setState({
          overNavbar: overNavbar,
          overMenu: overMenu
        });
      }
    });

    _this.state = {
      overNavbar: false,
      overMenu: false
    };
    _this.onMouseMove = _debounce(_this.onMouseMove, 100);
    return _this;
  }

  _createClass(ReportMouseHover, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.body.addEventListener('mousemove', this.onMouseMove);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('mousemove', this.onMouseMove);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          overNavbar = _this$state.overNavbar,
          overMenu = _this$state.overMenu;
      var el = this.props.el;
      return /*#__PURE__*/React.createElement(Block, {
        layout: true,
        vertical: true,
        flex: true,
        el: el,
        elementRef: this.setElementRef
      }, this.props.render({
        overNavbar: overNavbar,
        overMenu: overMenu
      }));
    }
  }]);

  return ReportMouseHover;
}(React.Component);

ReportMouseHover.propTypes = {
  el: PropTypes.string,
  menuRef: PropTypes.object,
  render: PropTypes.func
};
ReportMouseHover.defaultProps = {
  el: 'div'
};
export default ReportMouseHover;